import { createHook, createStore } from 'react-sweet-state';
import type { State } from '../../common/types';
import { actions, type Actions } from './actions';
import { getConnectionStatus } from './selectors/get-connection-status';

const initialState: State = {
    connectionStatus: {
        data: {
            googleDrive: undefined,
            sharepoint: undefined,
        },
        isFetched: false,
    },
};
export const store = createStore<State, Actions>({
    initialState,
    actions,
    name: 'KnowledgeBaseThirdPartyConnectors',
});

export const useConnectionStatus = createHook(store, {
    selector: getConnectionStatus,
});
